import axios from 'axios';
import { applyAuthRequestInterceptor, applyEnvelopeInterceptor } from './axiosInterceptors';
import { API_BASE } from './runtimeConfig';

/**
 * Creates an authenticated axios instance.
 * Identity headers (X-User-Id, X-Organization-Id, etc.) are injected
 * by the API Gateway from the JWT session — no need to set them here.
 */
function createServiceClient(path: string) {
  const client = axios.create({
    baseURL: `${API_BASE}${path}`,
    timeout: 30000,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });

  applyAuthRequestInterceptor(client);
  applyEnvelopeInterceptor(client);

  return client;
}

/** Contract-service: templates, reviews, onlyoffice editor */
export const contractServiceClient = createServiceClient('/api/contract-service');

/** File-management-service: upload, download, delete */
export const fileManagementClient = createServiceClient('/api/file-management-service');

/** @deprecated — use contractServiceClient or fileManagementClient */
const documentServiceClient = contractServiceClient;
export default documentServiceClient;
